

import React, { useEffect, useState } from 'react';
import Snackbar from '@mui/material/Snackbar';
import { Box, Fade, Slide } from '@mui/material';
import { NotificationModel } from '../../../NotificationModel';
import { MyAlert } from './MyAlertComponet';


interface myProps {
    notification: NotificationModel;
}
export const MyNotification: React.FC<myProps> = (props) => {

    const [open, setOpen] = useState(true);
    const [notification, setNotification] = useState<NotificationModel>()
    const handleClose = () => {
        setOpen(false);
    };
    useEffect(() => {
        if (props.notification) {
            setNotification(props.notification)
            setOpen(true)
        }
    }, [props.notification])

    return (
        <>
            <Snackbar
                open={open}
                autoHideDuration={3000}
                onClose={handleClose}
                message={"label" + " copié"}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                TransitionComponent={Slide}
            >
                <Box sx={{ border: '1px solid green' }}>
                    {notification && <MyAlert notification={notification} />}
                </Box>
            </Snackbar>
        </>
    );
};


